import { lazy } from 'react';
import { RouteProps } from '@/typings';

const Dashboard = lazy(() => import('@/pages/Dashboard'));
const Estancias = lazy(() => import('@/pages/Estancias'));
const RegistroEstancia = lazy(() => import('@/pages/RegistroEstancia'));
const CorreccionEstancia = lazy(() => import('@/pages/CorreccionEstancia'));
const RegistroTipoEstancia = lazy(() => import('@/pages/RegistroTipoEstancia'));
const RegistroInstitucion = lazy(() => import('@/pages/RegistroInstitucion'));
const DetallesEstancia = lazy(() => import('@/pages/DetallesEstancia'));

const rutasPrivadas: RouteProps[] = [
  {
    path: '/Dashboard',
    element: <Dashboard />,
  },
  {
    path: '/Estancias',
    element: <Estancias />,
  },
  {
    path: '/Estancias/Registro',
    element: <RegistroEstancia />,
  },
  {
    path: '/Estancias/Registro/:id',
    element: <CorreccionEstancia />,
  },
  {
    path: '/Estancias/RegistroTipoEstancia',
    element: <RegistroTipoEstancia />,
  },
  {
    path: '/Estancias/RegistroInstitucion',
    element: <RegistroInstitucion />,
  },
  {
    path: '/Estancias/:id',
    element: <DetallesEstancia />,
  },
];

export default rutasPrivadas;
